/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApproveTransferRequestDto } from '../models/ApproveTransferRequestDto';
import type { ApproveTransferRequestEntity } from '../models/ApproveTransferRequestEntity';
import type { CreateTransferRequestDto } from '../models/CreateTransferRequestDto';
import type { CreateTransferRequestEntity } from '../models/CreateTransferRequestEntity';
import type { GetTransferRequestDetailEntity } from '../models/GetTransferRequestDetailEntity';
import type { GetTransferRequestListEntity } from '../models/GetTransferRequestListEntity';
import type { ManualApproveTransferRequestDto } from '../models/ManualApproveTransferRequestDto';
import type { RejectTransferRequestEntity } from '../models/RejectTransferRequestEntity';
import type { RejectTransferRequestsDto } from '../models/RejectTransferRequestsDto';
import type { UploadEvidenceDto } from '../models/UploadEvidenceDto';
import type { UploadEvidenceEntity } from '../models/UploadEvidenceEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TransferWithEvidenceService {
  /**
   * @param requestBody
   * @returns UploadEvidenceEntity
   * @throws ApiError
   */
  public static transferWithEvidenceControllerUploadEvidence(
    requestBody: UploadEvidenceDto,
  ): CancelablePromise<UploadEvidenceEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/transfer-with-evidence/transfer-requests/evidence-upload-url',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param requestBody
   * @returns CreateTransferRequestEntity
   * @throws ApiError
   */
  public static transferWithEvidenceControllerCreate(
    requestBody: CreateTransferRequestDto,
  ): CancelablePromise<CreateTransferRequestEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/transfer-with-evidence/transfer-requests',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param fromTime
   * @param toTime
   * @param status
   * @param companyId
   * @param phoneNumber
   * @param page
   * @param size
   * @returns GetTransferRequestListEntity
   * @throws ApiError
   */
  public static transferWithEvidenceControllerGetAllList(
    fromTime?: string,
    toTime?: string,
    status?:
      | 'ALL'
      | 'PENDING_APPROVAL'
      | 'PENDING_BIDV_SUBMIT'
      | 'PROCESSING'
      | 'COMPLETED'
      | 'FAILED'
      | 'SUBMIT_FAILED'
      | 'TIMEOUT'
      | 'REJECTED',
    companyId?: string,
    phoneNumber?: string,
    page?: number,
    size?: number,
  ): CancelablePromise<GetTransferRequestListEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/transfer-with-evidence/transfer-requests',
      query: {
        fromTime: fromTime,
        toTime: toTime,
        status: status,
        companyId: companyId,
        phoneNumber: phoneNumber,
        page: page,
        size: size,
      },
    });
  }

  /**
   * @param fromTime
   * @param toTime
   * @param status
   * @param page
   * @param size
   * @param companyId
   * @returns GetTransferRequestListEntity
   * @throws ApiError
   */
  public static transferWithEvidenceControllerGetOwnList(
    fromTime?: string,
    toTime?: string,
    status?:
      | 'ALL'
      | 'PENDING_APPROVAL'
      | 'PENDING_BIDV_SUBMIT'
      | 'PROCESSING'
      | 'COMPLETED'
      | 'FAILED'
      | 'SUBMIT_FAILED'
      | 'TIMEOUT'
      | 'REJECTED',
    page?: string,
    size?: string,
    companyId?: string,
  ): CancelablePromise<GetTransferRequestListEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/transfer-with-evidence/transfer-requests/own',
      query: {
        fromTime: fromTime,
        toTime: toTime,
        status: status,
        page: page,
        size: size,
        companyId: companyId,
      },
    });
  }

  /**
   * @param id
   * @param requestBody
   * @returns ApproveTransferRequestEntity
   * @throws ApiError
   */
  public static transferWithEvidenceControllerManualApprove(
    id: string,
    requestBody: ManualApproveTransferRequestDto,
  ): CancelablePromise<ApproveTransferRequestEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/transfer-with-evidence/transfer-requests/{id}/manual-approve',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param requestBody
   * @returns ApproveTransferRequestEntity
   * @throws ApiError
   */
  public static transferWithEvidenceControllerBidvApprove(
    requestBody: ApproveTransferRequestDto,
  ): CancelablePromise<ApproveTransferRequestEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/transfer-with-evidence/transfer-requests/bidv-approve',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param requestBody
   * @returns RejectTransferRequestEntity
   * @throws ApiError
   */
  public static transferWithEvidenceControllerReject(
    requestBody: RejectTransferRequestsDto,
  ): CancelablePromise<RejectTransferRequestEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/transfer-with-evidence/transfer-requests/reject',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param id
   * @returns GetTransferRequestDetailEntity
   * @throws ApiError
   */
  public static transferWithEvidenceControllerGetDetail(
    id: string,
  ): CancelablePromise<GetTransferRequestDetailEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/transfer-with-evidence/transfer-requests/{id}',
      path: {
        id: id,
      },
    });
  }
}
